module.exports = __webpack_public_path__ + "static/img/47060.5ac408e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/47060.jpg
// module id = beJU
// module chunks = 1